const hiddenClasses = [
  '.modal-overlay',
  '.modal',
  '.cmp-store-locator-prompt',
];

const skeletonClasses = [
  'cmp-skeleton',
  'cmp-skeleton--gradient',
  'cmp-skeleton__carousel__description-wrapper',
  'cmp-skeleton__carousel__img',
  'cmp-skeleton__deals-card',
  'cmp-skeleton__sorting__heading',
  'cmp-skeleton__sorting__dropdown',
  'cmp-skeleton__product-card__wrapper',
  'cmp-skeleton__product-card__img',
  'cmp-skeleton__product-card__manufacturer',
  'cmp-skeleton__product-card__name',
  'cmp-skeleton__product-card__text',
  'cmp-skeleton__product-card__link',
  'cmp-skeleton__product-card__specifications',
  'cmp-skeleton__product-card__financing',
  'cmp-skeleton__product-card__deals',
  'cmp-skeleton__product-card__rebates',
  'cmp-skeleton__product-card__quantity',
  'cmp-skeleton__product-card__add-to-cart',
  'cmp-skeleton__tire-card',
  'cmp-skeleton__generic-card',
  'cmp-product-search__hero--placeholder',
];

export const toggleLoadingSkeleton = (visible) => {
  if (visible) {
    document.querySelectorAll(hiddenClasses.join(', ')).forEach((element) => {
      element.style.display = 'none';
    });

    skeletonClasses.forEach((name) => {
      const skeletonClass = document.querySelectorAll(`.${name}`);
      skeletonClass.forEach((skeleton) => {
        skeleton.classList.add(`${name}--animated`);
      });
    });
    return;
  }

  document.querySelectorAll(hiddenClasses.join(', ')).forEach((element) => {
    element.style.display = '';
  });

  skeletonClasses.forEach((name) => {
    const skeletonClass = document.querySelectorAll(`.${name}`);
    skeletonClass.forEach((skeleton) => {
      skeleton.classList.remove(`${name}--animated`);
    });
  });
};
